import { useQuery } from '@tanstack/react-query';
import { searchQueryOptions } from '@/modules/search/api/search.query';
import type { GlobalSearchParams } from '@/modules/search/types';

/** Fan-out global search. Pass the *debounced* term — the query self-disables
 *  below MIN_SEARCH_LENGTH, so short/empty terms never hit the network. */
export function useGlobalSearchQuery(params: GlobalSearchParams) {
    return useQuery(searchQueryOptions.global(params));
}
